import { useState, React } from "react";
import "./../../assets/css/MapDropdown.scss";

export default function HistoryDropDown({ handleCalback }) {
  const options = ["30 Days", "60 Days", "90 Days", "6 months", "1 year","All"];

  const [isOpen, setIsOpen] = useState(false);
  const [haveText, setHaveText] = useState("");

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleText = (value) => {
    setHaveText(value);
    handleCalback(value); 
  };

  const itemList = (props) => {
    const list = props?.map((item) => (
      <div
        onClick={() => {
          handleText(item);
        }}
        className="dropdown__item"
        key={item?.toString()}
      >
        {item}
      </div>
    ));

    return <div className="dropdown__items"> {list} </div>;
  };

  return (
    <div
      className={isOpen ? "map_dropdown map_dd active" : "map_dropdown map_dd"}
      onClick={handleClick}
    >
      <div className="dropdown__text">
        {!haveText ? "60 Days" : haveText}
      </div>
      {itemList(options)}
    </div>
  );
}
